module.exports = __webpack_public_path__ + "img/email__green.43b4c92d.svg";